// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ProtectedImage_imageWrapper__p9KOb","overlay":"ProtectedImage_overlay__5EXzQ"};